import { createContext } from "react";

const cnx = createContext(null);

export default cnx;